module.exports = __webpack_public_path__ + "img/icon298.bf604797.png";